import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2165844e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-container" }
const _hoisted_2 = { class: "question-container" }
const _hoisted_3 = { class: "question-text p6 f14" }
const _hoisted_4 = { class: "conditionals-container" }
const _hoisted_5 = { class: "conditionals-content" }
const _hoisted_6 = { class: "card-conditionals conditional-questions" }
const _hoisted_7 = { class: "flex align-center" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "card-conditionals conditional-result" }
const _hoisted_10 = {
  class: "f20",
  style: {"text-align":"center"}
}
const _hoisted_11 = { class: "flex justify-around" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_14 = {
  key: 1,
  class: "f20"
}
const _hoisted_15 = { class: "conditionals-action" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SeFadeButton = _resolveComponent("SeFadeButton")!
  const _component_SeModal = _resolveComponent("SeModal")!
  const _component_SeButton = _resolveComponent("SeButton")!
  const _component_WideCard = _resolveComponent("WideCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SeModal, {
      style: {"z-index":"11"},
      title: _ctx.Lang.getI18N('select-question'),
      ref: "addQuestionModal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.booleanQuestions, (booleanQuestion) => {
              return (_openBlock(), _createBlock(_component_SeFadeButton, {
                icon: `/ico/form-${booleanQuestion.type}.svg`,
                iconRight: true,
                class: _normalizeClass({
            w100: true,
          }),
                style: {"justify-content":"start","margin-top":"5px"},
                key: booleanQuestion.id,
                onClick: ($event: any) => (_ctx.onQuestionSelect(booleanQuestion))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.truncateText(booleanQuestion.text, 35)), 1)
                ]),
                _: 2
              }, 1032, ["icon", "onClick"]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_SeModal, {
      title: _ctx.Lang.getI18N('add-condition'),
      ref: "addConditionModal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_SeButton, {
                  class: "w100",
                  onPress: () => _ctx.openQuestionModal(),
                  icon: "/ico/plus.svg",
                  disabled: _ctx.booleanQuestions.length <= 0
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("add-question")), 1)
                  ]),
                  _: 1
                }, 8, ["onPress", "disabled"])
              ]),
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedQuestion.conditions, (condition) => {
                  return (_openBlock(), _createBlock(_component_WideCard, {
                    class: "shadow",
                    key: condition.id,
                    obj: condition,
                    onClick: ($event: any) => (_ctx.onSelectedConditionChange(condition)),
                    isSelected: condition === _ctx.selectedCondition
                  }, {
                    body: _withCtx(() => [
                      _createElementVNode("img", {
                        src: `/ico/form-${_ctx.localAudit.getQuestionById(condition.question_id)!.type}.svg`
                      }, null, 8, _hoisted_8),
                      _createElementVNode("span", null, _toDisplayString(_ctx.localAudit.getQuestionById(condition.question_id)!.text), 1)
                    ]),
                    footer: _withCtx(() => [
                      _createVNode(_component_SeFadeButton, {
                        onClick: [
                          _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                          ($event: any) => (_ctx.deleteCondition(condition.id))
                        ],
                        icon: "/ico/trash.svg"
                      }, null, 8, ["onClick"])
                    ]),
                    _: 2
                  }, 1032, ["obj", "onClick", "isSelected"]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              (Object.keys(_ctx.selectedCondition).length !== 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.Lang.getI18N("question-condition") + ":"), 1),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_SeButton, {
                        style: {"width":"100px"},
                        invert: _ctx.toggleQuestionCondition,
                        disabledWithoutStyles: true,
                        disabled: !_ctx.toggleQuestionCondition,
                        onPress: () => _ctx.onToggleConditionValue
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("no")), 1)
                        ]),
                        _: 1
                      }, 8, ["invert", "disabled", "onPress"]),
                      _createVNode(_component_SeButton, {
                        style: {"width":"100px"},
                        invert: !_ctx.toggleQuestionCondition,
                        disabledWithoutStyles: true,
                        disabled: _ctx.toggleQuestionCondition,
                        onPress: () => _ctx.onToggleConditionValue
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("yes")), 1)
                        ]),
                        _: 1
                      }, 8, ["invert", "disabled", "onPress"])
                    ]),
                    _hoisted_12,
                    _hoisted_13
                  ], 64))
                : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.Lang.getI18N("no-condition-info")), 1))
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_SeButton, {
              style: {"width":"20%"},
              onPress: () => _ctx.closeModal(_ctx.$refs.addConditionModal)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("save")), 1)
              ]),
              _: 1
            }, 8, ["onPress"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["title"])
  ], 64))
}